import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Tracker } from '../../../../models/interfaces/status-tracker.interfaces';
import { HeaderComponent } from '../header/header.component';
import { JourneyComponent } from '../journey/journey.component';
import { LegendsComponent } from '../legends/legends.component';
import { ProgressGaugeComponent } from '../progress-gauge/progress-gauge.component';

@Component({
  selector: 'idp-tracker',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    ProgressGaugeComponent,
    HeaderComponent,
    LegendsComponent,
    JourneyComponent
  ],
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.scss']
})
export class TrackerComponent {
  @Input() content: Tracker = {} as Tracker;
  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() analyticsData = new EventEmitter<Event>();
}
